var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg0Abbaa1A6573B86A6E8271Fd44383Cf732Ebb8C6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 512 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 55",
    d: "M52.8421 0H502L449.158 104H0L52.8421 0Z",
    fill: "url(#paint0_linear_2002_40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 56",
    d: "M62.8421 13H512L459.158 117H10L62.8421 13Z",
    fill: "url(#paint1_linear_2002_40)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2002_40",
    x1: -77,
    y1: 52,
    x2: 502,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#992020",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2002_40",
    x1: -67,
    y1: 65,
    x2: 512,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#992020",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0Abbaa1A6573B86A6E8271Fd44383Cf732Ebb8C6);
export default __webpack_public_path__ + "static/media/0abbaa1a6573b86a6e8271fd44383cf732ebb8c6.900709a37db8dbb306b80b431e665d80.svg";
export { ForwardRef as ReactComponent };